import { render, staticRenderFns } from "./ServiceConfig.vue?vue&type=template&id=a164fa1c&scoped=true"
import script from "./ServiceConfig.vue?vue&type=script&lang=js"
export * from "./ServiceConfig.vue?vue&type=script&lang=js"
import style0 from "./ServiceConfig.vue?vue&type=style&index=0&id=a164fa1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a164fa1c",
  null
  
)

export default component.exports